__turbopack_context__.v({
  "chevron": "tqqM_W_chevron",
  "collapseToggle": "tqqM_W_collapseToggle",
});
